var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"gradientyellow dmsansM",staticStyle:{"height":"31px"},attrs:{"text-center":"","pt-1":""}},[_c('span',[_vm._v(" © Optimal Living Experience 2023 ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }